import { defaultTo } from 'lodash-es';

export function defaultToUndefined<T>(
  value: T | null | undefined,
): T | undefined {
  return defaultTo(value, undefined);
}
